import React, { useState, useRef, useEffect } from "react";

const CoordinateInput = ({ onChange, value, accuracy = 5 }: any) => {
  const [inputValue, setInputValue] = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);
  const sizerRef = useRef<HTMLSpanElement>(null);
  const _accuracy = accuracy < 1 ? 1 : accuracy;
  const patternString = `^-?\\d{1,3}\\.\\d{1,${_accuracy};-?\\d{1,3}\\.\\d{1,${_accuracy}$`;
  const coordinateRegex = new RegExp(patternString);

  useEffect(() => {
    if (sizerRef.current && inputRef.current) {
      inputRef.current.style.width = `${sizerRef.current.offsetWidth}px`;
    }
  }, [inputValue]);

  useEffect(() => {
    if (value) {
      setInputValue(value);
    }
  }, [value]);

  const handleChange = (e: any) => {
    const inputValue = e.target.value;
    const cursorPosition = e.target.selectionStart;
    const sanitizedInput = inputValue.replace(/[^0-9;\.-]/g, "");
    const parts = sanitizedInput.split(";");

    if (parts.length > 2) return;

    let newCursorPosition = cursorPosition;

    const validParts = parts.map((part: any, index: any) => {
      const [integer = "", decimal = ""] = part.split(".");

      let truncatedInteger = integer;
      let truncatedDecimal = decimal.replace('-', '');

      const isNegative = truncatedInteger.startsWith("-");
      const maxIntegerLength = isNegative ? 4 : 3;

      if (integer.length > maxIntegerLength) {
        truncatedInteger = integer.slice(0, maxIntegerLength);
        if (index === 0 && cursorPosition > maxIntegerLength) {
          newCursorPosition -= integer.length - maxIntegerLength;
        }
      }

      if (decimal.length > _accuracy) {
        truncatedDecimal = decimal.slice(0, _accuracy);
        if (index === 0 && cursorPosition > integer.length + 1 + _accuracy) {
          newCursorPosition -= decimal.length - _accuracy;
        }
      }

      if (part.endsWith(".") && decimal === '') {
        if (integer === '') {
          return '';
        }
        return `${truncatedInteger}.`;
      }
      
      return truncatedDecimal ? `${truncatedInteger}.${truncatedDecimal}` : decimal ? `${truncatedInteger}.` : truncatedInteger;
    });

    const processedValue = validParts.join(";");

    setInputValue(processedValue);

    setTimeout(() => {
      const inputElement = inputRef.current;
      if (inputElement) {
        inputElement.selectionStart = inputElement.selectionEnd = newCursorPosition;
      }
    }, 0);

    if (coordinateRegex.test(processedValue)) {
      onChange(processedValue)
    }
  };

  return (
    <div style={{ display: "inline-block", position: "relative" }}>
      <span
        ref={sizerRef}
        style={{
          position: "absolute",
          visibility: "hidden",
          whiteSpace: "pre",
          fontSize: "12px",
          fontFamily: "inherit",
        }}
      >
        {inputValue}
      </span>
      <input
        ref={inputRef}
        type="text"
        value={inputValue}
        onChange={handleChange}
        style={{
          fontSize: "12px",
          border: 'none',
          padding: "0",
          width: "1px",
          minWidth: "50px",
          maxWidth: "100%",
          boxSizing: "border-box",
          outline: 'none',
        }}
      />
    </div>
  );
};

export default CoordinateInput;






